import api from 'api-client'

const state = {
    dashboard: null,
    dashboards: [],
    selectedF1Event: 'all',
    eventTargets: []
}

const getters = {
    dashboard: state => state.dashboard,
    dashboards: state => state.dashboards,
    selectedF1Event: state => state.selectedF1Event,
    eventTargets: state => state.eventTargets
}

const mutations = {
    setDashboard (state, dashboard) {
        state.dashboard = dashboard
    },
    setDashboards (state, dashboards) {
        state.dashboards = dashboards
    },
    addWidget (state, item) {
        item.layout.i = Date.now()
        state.dashboard.widgets.push(item)
    },
    removeWidget (state, id) {
        const widget =  state.dashboard.widgets.find(widget => widget.layout.i === id)
        state.dashboard.widgets.splice(state.dashboard.widgets.indexOf(widget), 1)
    },
    setSelectedF1Event(state, eventId) {
        state.selectedF1Event = eventId;
    },
    setEventTargets(state, targets) {
        state.eventTargets = targets;
    }
}

const actions = {
    getUserDashboard (state) {
        return api.getUserDashboard()
            .then(result => state.commit('setDashboard', result))
    },
    getDashboard (state, query) {
        return api.getDashboard(query)
            .then(result => state.commit('setDashboard', result))
    },
    getDashboards (state) {
        return api.getDashboards()
            .then(result => state.commit('setDashboards', result))
    },
    newDashboard (state, newDashboard) {
        return api.createDashboard(newDashboard)
            .then(result => state.commit('setDashboard', result))
    },
    updateDashboard ({ commit }, dashboard) {
        return api.updateDashboard(dashboard)
    },
    deleteDashboard({ dispatch }, id) {
        return api.deleteDashboardById(id)
            .then(() => dispatch('getDashboards'))
    },
    addWidget (state, item) {
        state.commit('addWidget', item)
    },
    removeWidget (state, { id }) {
        state.commit('removeWidget', id)
    },
    async getEventTargets({ commit }) {
        try {
            const response = await api.getEventGroupTargetSales();

            
            // Validate the response
            if (Array.isArray(response)) {
                response.forEach((item, index) => {
                    if (!item.FK_EventGroup) {
                        // console.warn(`Event target item ${index} missing FK_EventGroup:`, item);
                    } else {
                        // Ensure FK_EventGroup is a string for consistency
                        item.FK_EventGroup = String(item.FK_EventGroup);
                        // console.log(`Normalized FK_EventGroup for item ${index}: ${item.FK_EventGroup} (${typeof item.FK_EventGroup})`);
                    }
                });
                
                // Filter out invalid items
                const validTargets = response.filter(item => item.FK_EventGroup);
                // console.log('Valid event targets:', validTargets);
                
                commit('setEventTargets', validTargets);
                return response;
            } else {
                // console.warn('getEventGroupTargetSales returned non-array response:', response);
                commit('setEventTargets', []);
                return response;
            }
        } catch (error) {
            // console.error('Error fetching event targets:', error);
            return [];
        }
    }
}

export default {
    state, getters, mutations, actions
}
